import { useTranslation } from "react-i18next";
import { NsKey } from "enums/NsKey";
import newMain from "assets/images/icons/dashboard/new-main.svg";
import manSearchBig from "assets/images/icons/dashboard/man-search-big.svg";
import { PersonSearchBar } from "features/subscription-process/components/person-search/PersonSearchBar";
import { SearchPersonResult } from "components/domain/SearchBar/types";

type InsuredPersonSearchPageProps = {
  showAddForm: () => void;
  withLegalEntity?: boolean;
  withNaturalPerson?: boolean;
  handleSelectPerson: (person: SearchPersonResult | null) => void
  /** Override the heading. Defaults to "Pour quel assuré créez-vous cette proposition ?". */
  title?: string;
  /** Override the search input placeholder. */
  searchPlaceholder?: string;
  /** Override the create-new button label. Defaults to "Créer un nouvel assuré". */
  createLabel?: string;
  /**
   * Scope la recherche aux Personnes rattachées à cette OU (Personne.PlateformeId).
   * Utilisé par les admins pour ne voir que les assurés d'une plateforme cible.
   */
  plateformeId?: string;
}

export const InsuredPersonSearchPage: React.FC<InsuredPersonSearchPageProps> = ({
  showAddForm,
  withNaturalPerson,
  withLegalEntity,
  handleSelectPerson,
  title,
  searchPlaceholder,
  createLabel,
  plateformeId,
}) => {
  const { t } = useTranslation(NsKey.ActorForm)

  return (
    <div className="max-w-5xl mx-auto">
      <div className="flex gap-8 w-full flex-col rounded-xl border bg-white px-8 py-14 text-center shadow">
        <div className="flex flex-col gap-2">
          <div className="flex justify-center items-center">
            <img src={manSearchBig} alt="new" />
          </div>
          <h2 className="text-lg font-bold text-gray-900">
            {title ?? t("ACTOR_FORM.LABELS.WHICH_INSURED_PERSON")}
          </h2>
        </div>
        <div className="mx-auto w-full max-w-2xl">
          <PersonSearchBar
            withNaturalPerson={withNaturalPerson}
            withLegalEntity={withLegalEntity}
            onSelect={handleSelectPerson}
            placeholder={searchPlaceholder}
            plateformeId={plateformeId}
          />
        </div>
        <button onClick={showAddForm} className="p-8 max-w-2xl w-full mx-auto flex flex-col items-center gap-4 bg-white border shadow rounded-2xl">
          <div className="flex justify-center items-center">
            <img src={newMain} alt="new" />
          </div>
          <p className="text-dark font-w700">{createLabel ?? t("ACTOR_FORM.LABELS.CREATE_NEW_INSURED_PERSON")}</p>
        </button>
      </div>
    </div>
  );
};
